import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { ProjectCreatePage } from '@/pages/projects/ui/ProjectCreatePage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

// URLクエリパラメータのスキーマ
const querySchema = z.object({
  /** 事業一覧からの遷移時に使用する */
  fromPdf: z.boolean().optional(),
});

export const Route = createFileRoute('/_protected/projects/create')({
  component: ProjectCreatePage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: querySchema,
      defaultValues: {
        fromPdf: false,
      },
    }),
});
